export const NAV_LABELS = {
    PROJECTS: "Projects",
    TABLE: "Table",
    MODELS: "Custom Models",
    TEMPLATES: "Templates",
    HISTORY: "History",
    SETTINGS: "Settings",
    INTEGRATIONS: "Integrations",
    MEMBERS: "Members",
    ORGANIZATION_SETTINGS: "Organization Settings",
    MY_ACCOUNT: "My Account",
    ADMIN: "Admin",
    NEW: "New",
    IMPORT: "Import",
    TRAIN_CUSTOM_MODEL: "Create",
} as const
